import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { LicenseTier } from './license-tier.model';
import { LicenseCoverageStatus } from './license-coverage-status.model';

@JsonObject()
export class LicenseCoverage {
  @JsonProperty('LicenseCount')
  licenseCount: number;

  @JsonProperty('ConnectorCount')
  connectorCount: number;

  @JsonProperty('Tier')
  tier: LicenseTier;

  @JsonProperty('Status')
  status: LicenseCoverageStatus;
}
